import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import Enums from "../enums/enums";
dayjs.extend(utc);

const Fullmonth = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const Shortmonth = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const monthsTh = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];
const monthsThMini = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];
const allThaiMonths = monthsTh.concat(monthsThMini);
const allEnMonths = Fullmonth.concat(Shortmonth);

const month = Fullmonth.concat(Shortmonth);
const IsThaiMonth = (pDate) => {
  let isThai = allThaiMonths.some((_month) => {
    return pDate.includes(`${_month}`);
  });

  return isThai;
};
const IsEnMonth = (pDate) => {
  let isEn = allEnMonths.some((_month) => {
    return pDate.includes(`${_month}`);
  });

  return isEn;
};

const getNumberThaiMonth = (pDate) => {
  let monthIndex = monthsThMini.findIndex((_month) => {
    return pDate.includes(`${_month}`);
  });
  if (monthIndex !== -1) return monthIndex + 1;
  monthIndex = monthsTh.findIndex((_month) => {
    return pDate.includes(`${_month}`);
  });
  if (monthIndex !== -1) return monthIndex + 1;
  return monthIndex;
};

const getNumberEnMonth = (pDate) => {
  let monthIndex = Shortmonth.findIndex((_month) => {
    return pDate.includes(`${_month}`);
  });
  if (monthIndex !== -1) return monthIndex + 1;
  monthIndex = Fullmonth.findIndex((_month) => {
    return pDate.includes(`${_month}`);
  });
  if (monthIndex !== -1) return monthIndex + 1;
  return monthIndex;
};

const convertDateMonth = (pDate, isThai = false) => {
  //* [0] = date, [1]month , [2] year
  const splitDate = pDate.split("-");
  const date = splitDate[0].length == 1 ? "0" + splitDate[0] : splitDate[0];

  let numberMonth = isThai ? getNumberThaiMonth(pDate) : getNumberEnMonth(pDate);

  if (numberMonth < 10) numberMonth = `0${numberMonth}`;
  const splitYearTime = splitDate[2].split(" ");

  const currentYearFull = new Date().getFullYear();

  const currentYear = GetCurrentYearFromYearStr(currentYearFull, splitYearTime[0]);

  const currentTime = splitYearTime[1] ? splitYearTime[1] : "00:00:00"; //! HH:mm:ss

  const fullDateFormat = `${currentYear}-${numberMonth}-${date} ${currentTime}`;

  const currentDate = dayjs(fullDateFormat, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss");

  return currentDate;
};

export const GetCurrentYearFromYearStr = (currentYearFull, yearString) => {
  let currentYear = 0;

  if (yearString.length === 2) {
    currentYear = 2000 + parseInt(yearString);

    const currentYearShort = String(currentYearFull).slice(-2);
    if (parseInt(yearString) - parseInt(currentYearShort) > 10) {
      //ถ้าเลขปี 2 ตัวหลังมากกว่าปี คศ ปัจจุบัน 10 ปี จะตีเป็น พศ
      currentYear = 2500 + parseInt(yearString) - 543;
    }
  } else if (yearString.length === 4) {
    currentYear = parseInt(yearString);

    if (currentYear - currentYearFull > 500) {
      //ถ้าปีลบกับปี คศ ปัจจุบันมีค่าห่างกันเกิน 500 ปี จะคิดว่าเป็น พศ และนำมาลบ 543
      currentYear -= 543;
    }
  }

  return currentYear;
};

const SplitStringDate = (date) => {
  if (!date) return [];
  if (date.includes("-")) return date.split("-");
  else if (date.includes("/")) return date.split("/");
  else return date.split(" ");
};

const IsStringDateType = (date) => {
  if (!date) return false;
  const splitDate = SplitStringDate(date);

  if (splitDate.length < 3) return false;
  const someMonth = month.some((_month) => _month.toUpperCase() === splitDate[1].toUpperCase());
  return someMonth;
};

const convertDateToISO = (date) => {
  // utc 0 เพราะเราไม่เก็บ time zone ใน db
  return dayjs(date).utc("+0").toISOString();
};

export default {
  convertDateMonth(pDate, isThai = false) {
    return convertDateMonth(pDate, isThai);
  },
  IsThaiMonth(pDate) {
    return IsThaiMonth(pDate);
  },
  getNumberThaiMonth(pDate) {
    return getNumberThaiMonth(pDate);
  },
  GetDueDateFromSetting(settingTransactionDueDate, selectedContact, { transactionType, financeType, expenseType }) {
    let dueDateResult = {
      isDueDateSetting: false,
      dueDateType: null,
      day: null,
    };

    if (settingTransactionDueDate?.length > 0) {
      let settingTransaction = null;

      if (
        transactionType === Enums.TransactionType.Invoice &&
        financeType === Enums.FinanceType.OutFlow &&
        expenseType === Enums.ExpenseType.PurchaseAsset
      ) {
        settingTransaction = settingTransactionDueDate.find(
          (x) =>
            x.transactionType === transactionType &&
            x.financeType === financeType &&
            x.transactionItemType === Enums.TransactionItemType.Asset
        );
      } else if (
        transactionType === Enums.TransactionType.InvoiceReceipt ||
        transactionType === Enums.TransactionType.GoodsReceipt
      ) {
        settingTransaction = settingTransactionDueDate.find(
          (x) =>
            x.transactionType === Enums.TransactionType.Invoice &&
            x.financeType === Enums.FinanceType.OutFlow &&
            x.expenseType !== Enums.ExpenseType.PurchaseAsset
        ); /* ตาม specs ให้ใช้ของบันทึกค่าใช้จ่าย */
      } else {
        settingTransaction = settingTransactionDueDate.find(
          (x) => x.transactionType === transactionType && x.financeType === financeType
        );
      }

      if (settingTransaction && settingTransaction.dueDateType !== Enums.DueDateSettingType.None) {
        dueDateResult.isDueDateSetting = true;
        dueDateResult.dueDateType = settingTransaction.settingDueDateType;
        dueDateResult.day = settingTransaction.day;
      }
    }

    if (selectedContact?.id > 0) {
      switch (transactionType) {
        case Enums.TransactionType.Invoice:
        case Enums.TransactionType.InvoiceReceipt:
        case Enums.TransactionType.GoodsReceipt:
          if (
            financeType === Enums.FinanceType.OutFlow &&
            selectedContact.outflowDueDateTypeId !== Enums.DueDateSettingType.None
          ) {
            dueDateResult.isDueDateSetting = true;
            dueDateResult.dueDateType = selectedContact.outflowDueDateTypeId;
            dueDateResult.day = selectedContact.outflowDueDateDay;
          } else if (
            financeType === Enums.FinanceType.InFlow &&
            selectedContact.incomeDueDateTypeId !== Enums.DueDateSettingType.None
          ) {
            dueDateResult.isDueDateSetting = true;
            dueDateResult.dueDateType = selectedContact.incomeDueDateTypeId;
            dueDateResult.day = selectedContact.incomeDueDateDay;
          }
          break;
      }
    }

    return dueDateResult;
  },
  SetDueDate(startDate, dueDateType, day) {
    let date = new Date(startDate);
    switch (dueDateType) {
      case Enums.DueDateSettingType.DateDistanctNextMonth:
        date = new Date(date.getFullYear(), date.getMonth() + 1, day);
        break;
      case Enums.DueDateSettingType.EndOfMonth:
        date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        break;
      case Enums.DueDateSettingType.EndOfMonthFromNextMonth:
        date = new Date(date.getFullYear(), date.getMonth() + 2, 0);
        break;
      default:
        date.setDate(date.getDate() + day);
        break;
    }
    return date.ToDateJsonString();
  },

  IsStringDateType(date) {
    return IsStringDateType(date);
  },
  IsEnMonth(date) {
    return IsEnMonth(date);
  },
  convertDateToISO(date) {
    return convertDateToISO(date);
  },
  GetDefaultDayDueDateForTransaction() {
    return 7;
  },
};
